<div class="maindiv">
  <div class=" inputdiv">
    <div>
      <div>
        <div style="margin: 5px;"><label i18n="@@Username">Username</label></div>
        <input #username name="username" pInputText [(ngModel)]="userName"  autocomplete="off"/>
      </div>
      <div>
        <div style="margin: 5px;"><label i18n="@@Password">Password</label></div>
        <!--    <p-password  [(ngModel)]="password" ></p-password>-->
        <input [(ngModel)]="password" name="password"  autocomplete="off"  pInputText  type="password"/>
      </div>
    </div>
    <div style="text-align: left;margin-top: 10px">
      <button pButton (click)="login()" i18n-label="@@Login" label="Login"></button>
    </div>
  </div>

</div>
<p-toast position="bottom-left" [hideTransitionOptions]="'0ms'"></p-toast>
